import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import * as dayjs from 'dayjs';
import { CommonService } from 'src/app/services/common.service';
import { distinct, from, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ResponseMessageStatus, ResponseStatus } from 'src/app/shared/enums';
import { BadeLoftService } from '../bade-loft.service';
import moment from 'moment';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-orders-new',
  templateUrl: './orders-new.component.html',
  styleUrls: ['./orders-new.component.css'],
})
export class OrdersNewComponent implements OnInit {
  isDataLoading: boolean = false;
  moment = moment;
  currentFilterDate = 1;
  quickbooksData: any[] = [''];
  quickbooksDataCopy: any[] = [];
  wooCommerceData: any[] = [''];
  wooCommerceDataCopy: any[] = [];
  // WooCommerce server-side paging/sort/search state (WooCommerce tab only).
  wooPageIndex: number = 1;
  wooPageSize: number = 25;
  wooTotal: number = 0;
  wooSortBy: string = 'date';
  wooSortDir: string = 'desc';
  wooSearch: string = '';
  private wooSearch$ = new Subject<void>();
  searchTextOrder: any;
  searchTextInvoice: any;
  searchTextBLStatus: any;
  searchTextWooStatus: any;
  selectedDateRangeQBO: any = {};
  selectedDateRangeWOO: any = {};
  isLoadingQBOData: boolean = false;
  isDataLoadingWoo: boolean = false;
  radioValueQBO = 'A';
  radioValueWOO = 'A';
  radioValueTable = 'A';
  assignemntForInvoice: any;
  currentSelectedIndex = 0;
  listOfColumns: any[] = [
    {
      name: 'Order Date',
      sortOrder: null,
      sortFn: (a: any, b: any) => b.orderDate.localeCompare(a.orderDate),
      sortDirections: ['ascend', 'descend', null],
    },
    {
      name: 'Order Number',
      sortOrder: null,
      sortFn: (a: any, b: any) => b.orderNumber.localeCompare(a.orderNumber),
      sortDirections: ['ascend', 'descend', null],
    },
    {
      name: 'Wayfair Customer Name',
      sortOrder: null,
      sortDirections: ['ascend', 'descend', null],
      sortFn: (a: any, b: any) => a.cutomerName.localeCompare(b.cutomerName),
    },
    {
      name: 'QB Invoice#',
      sortOrder: null,
      sortDirections: ['ascend', 'descend', null],
      sortFn: (a: any, b: any) => a.qboInvoiceNo - b.qboInvoiceNo,
    },
  ];

  ranges: any = {
    Today: [moment(), moment()],
    Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    Tomorrow: [moment().add(1, 'days'), moment().add(1, 'days')],
    'This Week': [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [
      moment().subtract(1, 'month').startOf('month'),
      moment().subtract(1, 'month').endOf('month'),
    ],
  };
  timer: any = null;
  qbDataList_Request: any;
  wooCommerceDataList_Request: any;
  wayfairDataList_Request: any;
  isAssignmentVisible: boolean = false;
  editAssignmentDetail: any;
  invoiceNumber: any = '';
  fromDateQBO: any;
  fromDateWayfair: any;
  toDateQBO: any;
  fromDateWOO: any;
  toDateWOO: any;
  orderStatus: any = '';
  wayfairFromDateStr: any;
  sortDir: any = 0;
  isVisibleQBOFilter: boolean = false;
  isVisibleWOOFilter: boolean = false;
  isWayfairTable: boolean = false;
  DataType = {
    WooCommerce: 1,
    Wayfair: 2,
    Shopify: 3,
  };
  searchTextCustomerQB: string;
  searchTextCustomerWOO: any;
  searchTextOrderWayfair: string;
  wayfairData: any[] = [''];
  wayfairDataCopy: any[] = [];

  shopifyData: any[] = [''];
  shopifyDataCopy: any[] = [];
  isDataLoadingShopify: boolean = false;
  shopifyDataList_Request: any;
  selectedDateRangeShopify: any = {};
  fromDateShopify: any;
  toDateShopify: any;

  constructor(
    private _blS: BadeLoftService,
    public _cS: CommonService,
    private cdref: ChangeDetectorRef,
    private _datepipe: DatePipe
  ) {}

  ngOnInit(): void {
    // Debounced WooCommerce search (order#/customer free-text): reset to page 1, then reload from server.
    this.wooSearch$.pipe(debounceTime(300)).subscribe(() => {
      this.wooPageIndex = 1;
      this.getWooCommerceData();
    });
    // this.selectedDateRangeQBO['startDate'] = moment().startOf('week');
    // this.selectedDateRangeQBO['endDate'] = moment().endOf('week');
    // this.selectedDateRangeQBO['startDate'].set({ hour: 5, minute: 30 });
    // this.selectedDateRangeQBO['endDate'].set({ hour: 5, minute: 29 });
    // this.selectedDateRangeWOO['startDate'] = moment().startOf('week');
    // this.selectedDateRangeWOO['endDate'] = moment().endOf('week');
    // this.selectedDateRangeWOO['startDate'].set({ hour: 5, minute: 30 });
    // this.selectedDateRangeWOO['endDate'].set({ hour: 5, minute: 29 });

    this.selectedDateRangeQBO.startDate = this.ranges['Last 7 Days'][0];
    this.selectedDateRangeQBO.endDate = this.ranges['Last 7 Days'][1];

    this.selectedDateRangeWOO.startDate = this.ranges['Last 7 Days'][0];
    this.selectedDateRangeWOO.endDate = this.ranges['Last 7 Days'][1];

    this.selectedDateRangeShopify.startDate = this.ranges['Last 7 Days'][0];
    this.selectedDateRangeShopify.endDate = this.ranges['Last 7 Days'][1];

    this.fromDateWayfair = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1
    );
    // Shopify is the default active tab (read-only listing); Woo/Wayfair load lazily on tab select.
    this.radioValueTable = 'S';
    this.onDateChangeShopify(this.selectedDateRangeShopify);
  }

  onDateChangeQBO(result: any) {
    if (result.startDate != null) {
      let startDate = result?.startDate?.utc()?.format();
      startDate = startDate.split('T')[0] + 'T00:00:00Z';
      let endDate = result?.endDate?.utc()?.format();
      endDate = endDate.split('T')[0] + 'T23:59:59Z';
      this.fromDateQBO = startDate;
      this.toDateQBO = endDate;
    }
    this.quickbooksData = [];
    // this.page = 1;
    if (this.qbDataList_Request) this.qbDataList_Request.unsubscribe();
    this.getQuickbooksData();
  }
  onDateChangeWayfair(fromDate: any) {
    if (this.wayfairDataList_Request)
      this.wayfairDataList_Request.unsubscribe();
    this.getWayfairData();
  }
  onDateChangeWOO(result: any) {
    if (result.startDate != null) {
      let startDate = result?.startDate?.utc()?.format();
      startDate = startDate.split('T')[0] + 'T00:00:00';
      let endDate = result?.endDate?.utc()?.format();
      endDate = endDate.split('T')[0] + 'T23:59:59';
      this.fromDateWOO = startDate;
      this.toDateWOO = endDate;
    }
    this.wooCommerceData = [''];
    // this.page = 1;

    if (this.wooCommerceDataList_Request)
      this.wooCommerceDataList_Request.unsubscribe();
    this.getWooCommerceData();
  }
  searchByInvoice() {
    this.quickbooksData = this.quickbooksDataCopy.filter((x: any) =>
      x.invoiceNumber
        .toLowerCase()
        .includes(this.searchTextInvoice?.toLowerCase())
    );
  }
  searchByCustomerQB() {
    this.quickbooksData = this.quickbooksDataCopy.filter((x: any) =>
      x.customerName
        .toLowerCase()
        .includes(this.searchTextCustomerQB?.toLowerCase())
    );
  }
  // Resolves the active bottom-table to a DataType (Shopify / WooCommerce / Wayfair) so the shared
  // filter popover searches the table currently on screen.
  getActiveOrderDataType(): number {
    if (this.radioValueTable == 'S') return this.DataType.Shopify;
    return this.radioValueTable == 'A'
      ? this.DataType.WooCommerce
      : this.DataType.Wayfair;
  }
  searchByOrderNumber(dataType: any) {
    if (dataType == this.DataType.WooCommerce) {
      // WooCommerce order-number search is server-side; debounce and reload at page 1.
      this.wooSearch = this.searchTextOrder || '';
      this.orderStatus = '';
      this.wooSearch$.next();
    } else if (dataType == this.DataType.Shopify) {
      this.shopifyData = this.shopifyDataCopy.filter((x: any) =>
        (x?.orderNumber || '')
          .toLowerCase()
          .includes(this.searchTextOrder?.toLowerCase())
      );
    } else {
      this.wayfairData = this.wayfairDataCopy.filter((x: any) =>
        x.orderNumber
          .toLowerCase()
          .includes(this.searchTextOrder?.toLowerCase())
      );
    }
  }
  searchByOrderStatus() {
    // WooCommerce-only: status must be an exact WooCommerce status (e.g. 'completed'); server-side, immediate.
    this.orderStatus = this.searchTextWooStatus || '';
    this.wooSearch = '';
    this.wooPageIndex = 1;
    this.getWooCommerceData();
  }
  searchByCustomer(dataType: any) {
    if (dataType == this.DataType.WooCommerce) {
      // WooCommerce `search` is broad (matches customer name/email too); debounce and reload at page 1.
      this.wooSearch = this.searchTextCustomerWOO || '';
      this.orderStatus = '';
      this.wooSearch$.next();
    } else if (dataType == this.DataType.Shopify) {
      this.shopifyData = this.shopifyDataCopy.filter((x: any) =>
        (x?.customerName || '')
          .toLowerCase()
          .includes(this.searchTextCustomerWOO?.toLowerCase())
      );
    } else {
      this.wayfairData = this.wayfairDataCopy.filter((x: any) =>
        x.cutomerName
          .toLowerCase()
          .includes(this.searchTextCustomerWOO?.toLowerCase())
      );
    }
  }
  sort(key: string) {
    if (key == 'invoiceDate') {
      this.sortDir = 0 ? 1 : 0;
      this.quickbooksData = this.quickbooksData.sort(
        (a, b) =>
          <any>new Date(b.invoiceDate) -
          <any>new Date(a.invoiceDate) * this.sortDir
      );
    }
  }
  SortquickbooksData(event: any, key: string) {
    event = event == 'ascend' ? 'descend' : 'ascend';
    if (event == 'ascend')
      this.quickbooksData.sort((a: any, b: any) =>
        a[key] < b[key] ? 1 : b[key] < a[key] ? -1 : 0
      );
    if (event == 'descend')
      this.quickbooksData.sort((a: any, b: any) =>
        a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0
      );
    if (event == null) {
      this.quickbooksData = [...this.quickbooksDataCopy];
    }
  }
  // WooCommerce sort/paging are server-driven (see getWooCommerceData); key is 'date' or 'number'.
  onWooSort(key: string, dir: 'asc' | 'desc') {
    this.wooSortBy = key;
    this.wooSortDir = dir;
    this.wooPageIndex = 1; // a new sort re-orders the whole result set — return to page 1
    this.getWooCommerceData();
  }
  onWooPageIndexChange(index: number) {
    this.wooPageIndex = index;
    this.getWooCommerceData();
  }
  onWooPageSizeChange(size: number) {
    this.wooPageSize = size;
    this.wooPageIndex = 1;
    this.getWooCommerceData();
  }
  SortWayfairData(event: any, key: string) {
    if (event == 'ascend') {
      this.wayfairData.sort((a: any, b: any) =>
        a[key] < b[key] ? 1 : b[key] < a[key] ? -1 : 0
      );
    }
    if (event == 'descend') {
      this.wayfairData.sort((a: any, b: any) =>
        a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0
      );
    }
    if (event == null) {
      this.wayfairData = [...this.wayfairDataCopy];
    }
  }
  loadWayfairData() {
    this.wooCommerceData = [''];
    if (this.wooCommerceDataList_Request)
      this.wooCommerceDataList_Request.unsubscribe();
    this.getWayfairData();
  }
  // Bottom-toggle change handler: load the selected channel's data (Shopify / WooCommerce / Wayfair).
  onOrderTableChange() {
    if (this.radioValueTable == 'S') {
      this.radioValueWOO = 'A';
      this.searchTextOrder = '';
      this.searchTextCustomerWOO = '';
      this.loadShopifyData();
      return;
    }
    // clearsearchDataWOO() already performs a single WooCommerce reload when the
    // active tab is WooCommerce; only Wayfair needs an extra fetch here.
    this.clearsearchDataWOO(this.radioValueTable == 'A' ? 1 : 2);
    if (this.radioValueTable == 'B') {
      this.getWayfairData();
    }
  }
  onDateChangeShopify(result: any) {
    if (result.startDate != null) {
      let startDate = result?.startDate?.utc()?.format();
      startDate = startDate.split('T')[0] + 'T00:00:00Z';
      let endDate = result?.endDate?.utc()?.format();
      endDate = endDate.split('T')[0] + 'T23:59:59Z';
      this.fromDateShopify = startDate;
      this.toDateShopify = endDate;
    }
    this.shopifyData = [''];
    if (this.shopifyDataList_Request) this.shopifyDataList_Request.unsubscribe();
    this.getShopifyOrders();
  }
  loadShopifyData() {
    this.shopifyData = [''];
    if (this.shopifyDataList_Request) this.shopifyDataList_Request.unsubscribe();
    this.getShopifyOrders();
  }
  // Order id currently syncing — drives the button spinner and blocks a second click, which
  // matters because a double-click is exactly the race the server-side claim guards against.
  syncingOrderId: string = '';

  // Both bindings MUST return a strict boolean. ng-zorro's `disabled` and `nzLoading` are
  // @InputBoolean() -> CDK coerceBooleanProperty (`value != null && `${value}` !== 'false'`), so an
  // empty string coerces to TRUE -- that is how a bare <button disabled> works. Binding the raw
  // expression `syncingOrderId && ...` yielded '' while idle and rendered Sync permanently disabled.
  isSyncDisabled(data: any): boolean {
    return !!this.syncingOrderId && this.syncingOrderId !== data.shopifyOrderId;
  }

  isSyncing(data: any): boolean {
    return !!this.syncingOrderId && this.syncingOrderId === data.shopifyOrderId;
  }

  manualSyncShopifyOrder(data: any) {
    if (this.syncingOrderId) return;
    this.syncingOrderId = data.shopifyOrderId;

    this._blS.manualSyncShopifyOrder(data.shopifyOrderId).subscribe(
      (response: any) => {
        this.syncingOrderId = '';
        const isSuccess = response?.responseStatus == ResponseStatus.Success;
        this._cS.displayMessage(
          isSuccess ? ResponseMessageStatus.success : ResponseMessageStatus.error,
          response?.message || 'Sync finished.'
        );
        // Refresh so the row picks up its new QB Invoice# and the button disappears.
        if (isSuccess) this.getShopifyOrders();
      },
      () => {
        this.syncingOrderId = '';
        this._cS.displayMessage(
          ResponseMessageStatus.error,
          'Sync could not be completed. Please try again.'
        );
      }
    );
  }

  getShopifyOrders() {
    this.isDataLoadingShopify = true;
    this.shopifyDataList_Request = this._blS
      .getOrdersShopify(this.fromDateShopify, this.toDateShopify)
      .subscribe(
        (response: any) => {
          if (response) {
            if (response.responseStatus == ResponseStatus.Success) {
              this.isDataLoadingShopify = false;
              this.shopifyData = response.result || [];
              this.shopifyDataCopy = JSON.parse(JSON.stringify(this.shopifyData));
              this.SortShopifyData('descend', 'orderDate');
            } else {
              this.isDataLoadingShopify = false;
              this._cS.displayMessage(
                ResponseMessageStatus.error,
                response.message
              );
            }
          }
        },
        () => {
          this.isDataLoadingShopify = false;
          this._cS.displayMessage(
            ResponseMessageStatus.error,
            'Failed to load Shopify orders'
          );
        }
      );
  }
  SortShopifyData(event: any, key: string) {
    event = event == 'ascend' ? 'descend' : 'ascend';
    if (event == 'ascend')
      this.shopifyData.sort((a: any, b: any) =>
        a[key] < b[key] ? 1 : b[key] < a[key] ? -1 : 0
      );
    if (event == 'descend')
      this.shopifyData.sort((a: any, b: any) =>
        a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0
      );
    if (event == null) {
      this.shopifyData = [...this.shopifyDataCopy];
    }
  }
  loadWOOData() {
    this.wooCommerceData = [''];
    if (this.wooCommerceDataList_Request)
      this.wooCommerceDataList_Request.unsubscribe();
    this.getWooCommerceData();
  }
  // ---- Manual "Sync" on the QBO tab: create the Shopify order this invoice never got ----
  // Invoice id currently syncing — drives the spinner and blocks a second click, which matters
  // because the reverse-create path is single-winner and a double-click would simply lose the claim.
  syncingInvoiceId: string = '';

  // Both bindings MUST return a strict boolean. ng-zorro's `disabled` and `nzLoading` are
  // @InputBoolean() -> CDK coerceBooleanProperty (`value != null && `${value}` !== 'false'`), so an
  // empty string coerces to TRUE — that is how a bare <button disabled> works. Same trap already
  // documented for the Shopify tab's isSyncDisabled above.
  isQboSyncDisabled(data: any): boolean {
    return !!this.syncingInvoiceId && this.syncingInvoiceId !== data.invoiceId;
  }

  isQboSyncing(data: any): boolean {
    return !!this.syncingInvoiceId && this.syncingInvoiceId === data.invoiceId;
  }

  manualSyncQBOInvoice(data: any) {
    if (this.syncingInvoiceId) return;
    this.syncingInvoiceId = data.invoiceId;

    this._blS.manualSyncQBOInvoice(data.invoiceId).subscribe(
      (response: any) => {
        this.syncingInvoiceId = '';
        const isSuccess = response?.responseStatus == ResponseStatus.Success;
        // response.message is the reverse path's OWN diagnosis, read back off RouteQBLogs —
        // "all lines unmatched, no Shopify variant", the recorded fault, or the created order.
        // Show it verbatim; a generic toast here would throw away the entire point of the button.
        this._cS.displayMessage(
          isSuccess ? ResponseMessageStatus.success : ResponseMessageStatus.error,
          response?.message || 'Sync finished.'
        );
        // Refresh so the row picks up its Channel badge and the button disappears.
        if (isSuccess) this.loadQBOData();
      },
      () => {
        this.syncingInvoiceId = '';
        this._cS.displayMessage(
          ResponseMessageStatus.error,
          'Sync could not be completed. Please try again.'
        );
      }
    );
  }

  loadQBOData() {
    this.quickbooksData = [];
    if (this.qbDataList_Request) this.qbDataList_Request.unsubscribe();
    this.getQuickbooksData();
  }
  getQuickbooksData() {
    this.isLoadingQBOData = true;
    this.qbDataList_Request = this._blS
      .getOrdersQBO(this.invoiceNumber, this.fromDateQBO, this.toDateQBO)
      .subscribe((response: any) => {
        if (response) {
          if (response.responseStatus == ResponseStatus.Success) {
            this.isLoadingQBOData = false;
            response.result.forEach((element: any) => {
              if (element.stockDetail != null) {
                var stocks = element.stockDetail;
                element.stockDetail = [];
                from(stocks)
                  .pipe(distinct())
                  .subscribe((x) => element.stockDetail.push(x));
              }
              if (element.isAssigned) {
                element.stocks = element.stockDetail?.join(',');
              } else {
                element.stocks = 'A';
              }
            });
            this.quickbooksData = response.result;
            this.quickbooksDataCopy = JSON.parse(
              JSON.stringify(response.result)
            );
            this.SortquickbooksData('descend', 'invoiceDate');
          } else {
            this.isLoadingQBOData = false;
            this._cS.displayMessage(
              ResponseMessageStatus.error,
              response.message
            );
          }
        }
      });
  }
  searchByBL() {
    this.quickbooksData = this.quickbooksDataCopy.filter((x: any) =>
      x.blStatus.toLowerCase().includes(this.searchTextBLStatus?.toLowerCase())
    );
  }
  getWooCommerceData() {
    this.isDataLoadingWoo = true;
    if (this.wooCommerceDataList_Request)
      this.wooCommerceDataList_Request.unsubscribe();
    this.wooCommerceDataList_Request = this._blS
      .getOrdersWoocommerce(
        this.orderStatus,
        this.fromDateWOO,
        this.toDateWOO,
        this.wooPageIndex,
        this.wooPageSize,
        this.wooSearch || '',
        this.wooSortBy,
        this.wooSortDir
      )
      .subscribe((response: any) => {
        if (response) {
          if (response.responseStatus == ResponseStatus.Success) {
            this.wooCommerceData = response.result?.items || [];
            this.wooTotal = response.result?.total || 0;
            this.isDataLoadingWoo = false;
          } else {
            this.isDataLoadingWoo = false;
            this._cS.displayMessage(
              ResponseMessageStatus.error,
              response.message
            );
          }
        }
      });
  }
  getWayfairData() {
    this.isDataLoading = true;
    this.wayfairFromDateStr = this._datepipe.transform(
      this.fromDateWayfair,
      'yyyy-MM-dd'
    );
    this.wayfairDataList_Request = this._blS
      .getOrdersWayfair(this.wayfairFromDateStr)
      .subscribe((response: any) => {
        if (response) {
          if (response.responseStatus == ResponseStatus.Success) {
            this.isDataLoading = false;
            if (response.result) {
              this.wayfairData = response.result;
              this.wayfairDataCopy = JSON.parse(
                JSON.stringify(response.result)
              );
            } else {
              this.wayfairData = [];
              this.wayfairDataCopy = [];
            }
            this.SortWayfairData('descend', 'orderDate');
          } else {
            this.isDataLoading = false;
            this._cS.displayMessage(
              ResponseMessageStatus.error,
              response.message
            );
          }
        }
      });
  }
  showAssignmentModal(data: any, isEdit?: any) {
    this.isAssignmentVisible = true;
    if (isEdit == true) {
      this.editAssignmentDetail = data;
      this.assignemntForInvoice = null;
      this.editAssignmentDetail['assigmentDetails'] = true;
    } else {
      this.editAssignmentDetail = null;
      this.assignemntForInvoice = data;
    }
  }
  deleteQBInvoice(data: any, i: any) {
    this._blS
      .deleteQuickBookInvoice(data.invoiceNumber)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.Success) {
          this.quickbooksData.splice(i, 1);
          this.quickbooksDataCopy = this.quickbooksData;
          this._cS.displayMessage(
            ResponseMessageStatus.success,
            response.message
          );
        } else {
          this._cS.displayMessage(
            ResponseMessageStatus.error,
            response.message
          );
        }
      });
  }
  confirmCompletion(
    orderId: any,
    index: any,
    isForCompleted: any,
    isForCancelled: any
  ) {
    this._blS
      .updateWoocommerceOrderStatus(orderId, isForCompleted, isForCancelled)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.Success) {
          if (isForCancelled) {
            this.wooCommerceData.splice(index, 1);
            this.wooCommerceDataCopy = this.wooCommerceData;
          } else {
            this.wooCommerceData[index].orderStatus = 'completed';
          }
          this._cS.displayMessage(
            ResponseMessageStatus.success,
            response.message
          );
        } else {
          this._cS.displayMessage(
            ResponseMessageStatus.error,
            response.message
          );
        }
      });
  }
  clearsearchDataQBO() {
    this.searchTextBLStatus = '';
    this.searchByBL();
    this.searchTextInvoice = '';
    this.searchByInvoice();
    this.searchTextCustomerQB = '';
    this.searchByCustomerQB();
  }
  clearsearchDataWOO(dataType: any) {
    this.searchTextOrder = '';
    if (dataType == this.DataType.WooCommerce) {
      // Reset Woo search state directly and reload ONCE. Do NOT chain
      // searchByOrderNumber/searchByOrderStatus/searchByCustomer here: two of them
      // reload immediately and the third reloads again after a 300ms debounce, so
      // a bulk reset (tab switch, "Search By" toggle, filter Close) used to fire up
      // to 3 identical WooCommerce requests and flicker the loading skeleton.
      this.searchTextWooStatus = '';
      this.searchTextCustomerWOO = '';
      this.wooSearch = '';
      this.orderStatus = '';
      this.wooPageIndex = 1;
      this.getWooCommerceData();
    } else {
      // Wayfair/Shopify keep their existing client-side filters (no server reload here).
      this.searchByOrderNumber(dataType);
      this.searchTextCustomerWOO = '';
      this.searchByCustomer(dataType);
    }
  }
  hideModal(event: any) {
    if (event.hide) {
      this.isAssignmentVisible = !event.hide;
    }
    if (event.data) {
      if (this.editAssignmentDetail) {
        var currentIndex = this.quickbooksData.findIndex(
          (x: any) => x.invoiceNumber == this.editAssignmentDetail.invoiceNumber
        );
      } else {
        var currentIndex = this.quickbooksData.findIndex(
          (x: any) => x.invoiceNumber == this.assignemntForInvoice.invoiceNumber
        );
      }
      this.quickbooksData[currentIndex].isAssigned = true;
      this.quickbooksData[currentIndex].assignmentId = event.data.id;
      // if (this.editAssignmentDetail) {
      var currentStockDetails = event.data.stocks
        ? event.data.stocks
        : event.data.assignmentStocks;
      // } else {
      //   var currentStockDetails = event.data.assignmentStocks;
      // }
      var qbStockDetail = currentStockDetails?.map((x: any) => {
        return x.stockName;
      });
      this.quickbooksData[currentIndex].stockDetail = [];
      from(qbStockDetail)
        .pipe(distinct())
        .subscribe((x) =>
          this.quickbooksData[currentIndex].stockDetail.push(x)
        );
      this.quickbooksData[currentIndex]['stocks'] =
        this.quickbooksData[currentIndex].stockDetail?.join(',');
      this.assignemntForInvoice = null;
    }
  }
  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }
}
